type InputData = {
	[key: string]: { operation: string }[] | unknown | null;
} | null;

export function mergeArrayOfObject(input: InputData): { operation: string }[] | null {
	if (!input) return null; // Handle null input

	let operationsArray: { operation: string }[] = [];

	for (const key in input) {
		if (key.toLowerCase().includes('role')) continue; // Skip keys containing "role"

		const value = input[key];

		if (Array.isArray(value)) {
			const filteredOperations = value.filter(
				(item): item is { operation: string } =>
					typeof item === 'object' && item !== null && 'operation' in item
			);

			operationsArray.push(...filteredOperations);
		}
	}

	return operationsArray;
}
